import _ from "lodash";

import React, { PureComponent } from "react";

import classes from "./SharedWith.scss";

import ScreenPanel from "../../ScreenPanel";
import I18nHOC from "UIComponents/I18nHOC";
import SharedWithList from "./SharedWithList";
import { Button } from "@toddle-edu/ds-web";
import { TickCircleFilled } from "@toddle-edu/ds-icons";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import { updatePost } from "Post/modules/PostModule";
import { getCurrentCurriculumProgramType } from "modules/CommonSelectors";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import { isPortfolioParityEnabledAndIsJournalRoute } from "AppComponents/Post/utils";

const styles = {
  titleTextStyle: { fontSize: "2rem" },
  footerContainerStyle: { height: "96px" },
  containerStyle: { padding: "0 32px" },
  titleContainerStyle: { marginTop: "30px" },
  itemContainerStyle: { borderBottom: "none", padding: "16px 0px" },
  headerContainerStyle: { padding: "0 24px 0 32px" },
  modalHeaderContainerStyle: { marginBottom: "16px" },
};

const BLANK_OBJECT = {};
const FooterComponent = React.memo(props => {
  const { onDoneClick, onCloseClick, showNewDesign, t } = props;
  return (
    <div className={classes.footerButtonContainer}>
      <Button
        size={"large"}
        onClick={onCloseClick}
        variant="outlined-subtle"
        style={{ marginRight: "12px" }}
        testId="journal-postcreation-sharewith-cancel"
      >
        {t("common:cancel")}
      </Button>
      <Button
        variant="progressive"
        size="large"
        onClick={onDoneClick}
        icon={showNewDesign ? <TickCircleFilled /> : null}
        testId="journal-postcreation-sharewith-done"
      >
        {t("done")}
      </Button>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";
class SharedWith extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHiddenFromStudents: props.isHiddenFromStudents,
      isPrivate: props.isPrivate,
    };
    this.containerRef = React.createRef();
  }

  updatePostVisibility = params => {
    this.setState({
      isHiddenFromStudents: _.get(
        params,
        "isHiddenFromStudents",
        this.state.isHiddenFromStudents
      ),
      isPrivate: _.get(params, "isPrivate", this.state.isPrivate),
    });
  };
  onDoneClick = () => {
    const { screenPanelProps: { onCloseClick } = _.noop } = this.props;
    this.props.updatePost({
      isHiddenFromStudents: this.state.isHiddenFromStudents,
      isPrivate: this.state.isPrivate,
    });
    onCloseClick();
  };

  render() {
    const { screenPanelProps, t } = this.props;
    const getFooterStyle = _.memoize(() => {
      const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
        path: "/journal",
      });
      return isJournalRoute
        ? {
            ...styles.footerContainerStyle,
            boxShadow: "none",
          }
        : styles.footerContainerStyle;
    });
    return (
      <ScreenPanel
        {...screenPanelProps}
        footerComponent={
          <FooterComponent
            t={t}
            onDoneClick={this.onDoneClick}
            onCloseClick={
              !_.isUndefined(screenPanelProps?.onCloseClick) &&
              screenPanelProps?.onCloseClick
            }
            showNewDesign={_.get(screenPanelProps, "showNewDesign", false)}
          />
        }
        titleTextStyle={styles.titleTextStyle}
        footerContainerStyle={getFooterStyle()}
        containerStyle={styles.containerStyle}
        titleContainerStyle={styles.titleContainerStyle}
        closeOnOutSideClick={true}
        parentContainerRef={this.containerRef}
        headerContainerStyle={
          isPortfolioParityEnabledAndIsJournalRoute()
            ? styles.headerContainerStyle
            : BLANK_OBJECT
        }
        modalHeaderContainerStyle={
          isPortfolioParityEnabledAndIsJournalRoute()
            ? styles.modalHeaderContainerStyle
            : BLANK_OBJECT
        }
      >
        <SharedWithList
          showNewDesign={_.get(screenPanelProps, "showNewDesign", false)}
          updatePostVisibility={this.updatePostVisibility}
          postVisibilityStatus={{
            isHiddenFromStudents: this.state.isHiddenFromStudents,
            isPrivate: this.state.isPrivate,
          }}
          showNewDesignV2={isPortfolioParityEnabledAndIsJournalRoute()}
          itemContainerStyle={styles.itemContainerStyle}
        />
      </ScreenPanel>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // get current shared with status from postDetails of state
  const isHiddenFromStudents = _.get(
    state,
    "post.postDetails.isHiddenFromStudents",
    true
  );
  const isPrivate = _.get(state, "post.postDetails.isPrivate", true);
  const curriculumProgramType = getCurrentCurriculumProgramType(state);
  return {
    isHiddenFromStudents,
    isPrivate,
    curriculumProgramType,
  };
};

const mapActionCreators = { updatePost };

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators)
)(SharedWith);
